module.exports = __webpack_public_path__ + "img/modalita-invio-alertmsg.e4a57bd3.png";